module.exports = __webpack_public_path__ + "static/media/18ECA7.b95e68ec.jpg";